import { api } from '../../api/api';

// initial state
const state = {
   recs:null,
   parcelFeatures:null,
   parcels:null,
   rec:null,
   unlocked:null,
   unlockedFeatures:null,
};

// getters
const getters = {
};

// actions
const actions = {
   COLLECTION_ADD:async (context, {name})=>{
      const res = await api.post('/api/collections',{name});

      await context.dispatch('COLLECTIONS_GET')
      return res.data
   },
   COLLECTION_GET:async (context, {collectionId})=>{
      const res = await api.get(`/api/collections/${collectionId}`);

      context.commit('COLLECTION_REC_SET',{
         rec:res.data
      })
   },
   COLLECTION_PARCEL_ADD:async (context, {addressId, collectionId, parcelId})=>{
      const res = await api.patch(`/api/collections/${collectionId}/parcels`,{
         add:[{
            addressId,
            parcelId
         }]
      });
      await context.dispatch('PARCEL_GET',{id:parcelId,addressId})
   },
   COLLECTIONS_PARCEL_FEATURES_GET:async (context, {collectionId})=>{
      const res = await api.get(`/api/collections/${collectionId}/parcels/centroids`);

      context.commit('COLLECTION_PARCEL_FEATURES_SET',{
         features:res.data
      })
   },
   COLLECTION_PARCEL_REMOVE:async (context, {addressId, collectionId, parcelId})=>{
      const res = await api.patch(`/api/collections/${collectionId}/parcels`,{
         remove:[{parcelId}]
      });
      await context.dispatch('PARCEL_GET',{id:parcelId,addressId})
   },
   COLLECTION_PARCELS_REMOVE:async (context, {collectionId, parcelIds})=>{
      const remove = parcelIds.map((parcelId)=>{
         return {parcelId}
      })
      const res = await api.patch(`/api/collections/${collectionId}/parcels`,{
         remove
      });
      context.dispatch('COLLECTION_PARCELS_GET', {collectionId})
   },
   COLLECTION_PARCELS_GET:async (context, {collectionId})=>{
      const res = await api.get(`/api/collections/${collectionId}/parcels`);

      await context.commit('COLLECTION_PARCELS_SET', {
         recs:res.data
      })
   },
   COLLECTION_REMOVE:async (context, {collectionId})=>{
      const res = await api.delete(`/api/collections/${collectionId}`);
   },
   COLLECTION_SAVE:async (context, {collectionId, name})=>{
      const res = await api.put(`/api/collections/${collectionId}`, {name});

      context.commit('COLLECTION_REC_SET',{
         rec:res.data
      })
   },
   COLLECTIONS_GET:async (context)=>{
      const res = await api.get('/api/collections');

      context.commit('COLLECTIONS_SET',{
         recs:res.data
      })
   },
   COLLECTIONS_UNLOCKED_GET:async (context)=>{
   	const res = await api.get('/api/parcels/unlocked');

   	context.commit('COLLECTIONS_UNLOCKED_SET',{
   		recs:res.data
   	})
   },
   COLLECTIONS_UNLOCKED_FEATURES_GET:async (context)=>{
   	const res = await api.get('/api/parcels/unlocked/features');

   	context.commit('COLLECTIONS_UNLOCKED_FEATURES_SET',{
   		features:res.data
   	})
   }
};

// mutations
const mutations = {
   COLLECTION_PARCELS_SET:(state, {recs})=>{
      state.parcels = recs;
   },
   COLLECTION_PARCEL_FEATURES_SET:(state, {features})=>{
      state.parcelFeatures = features;
   },
   COLLECTION_REC_SET:(state,{rec})=>{
      state.rec = rec;
   },
   COLLECTIONS_SET:(state,{recs})=>{
      state.recs = recs;
   },
	COLLECTIONS_UNLOCKED_SET:(state,{recs})=>{
      state.unlocked = recs;
   },
   COLLECTIONS_UNLOCKED_FEATURES_SET:(state,{features})=>{
      state.unlockedFeatures = features;
   }
};

export default {
   state,
   getters,
   actions,
   mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/collections.js